<template>
  <v-container fluid class="px-0">
    <div class="loadingorder-page">
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-text>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="rhead">
                    {{ initvalue.loadingordertype }} {{ initvalue.loadingordernum }}
                  </p>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" md="2" align="right">
                  <v-btn @click="Done" color="primary" text>
                <v-icon class="mr-2">mdi-check</v-icon>
                Done
                </v-btn>
                </v-col>
              </v-row>
              <v-row class="ma-1">
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Num</td>
                        <td>{{ initvalue.loadingordernum }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Date</td>
                        <td>{{ new Date(initvalue.loadingorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Name</td>
                        <td>{{ initvalue.loadingordername }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Loader</td>
                        <td class="tcell">{{ users.lenght>0 ? users.find(user=>user._id==initvalue.loaderid)['username'] : '' }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Driver</td>
                        <td class="tcell">{{ users.lenght>0 ? users.find(user=>user._id==initvalue.driverid)['username'] : '' }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Phone</td>
                        <td>{{ initvalue.loadingorderphone }}</td>
                      </tr>
                      <tr>
                        <td class="thead">Mobile</td>
                        <td>{{ initvalue.loadingorderphone }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
                <v-col cols="12" md="4">
                  <p class="two-line">
                    <table width="100%">
                      <tr>
                        <td class="thead">Note</td>
                        <td class="tcell">{{ initvalue.loadingordernote }}</td>
                      </tr>
                    </table>
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="loadingTab"
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-items'"
                    >
                      Loading
                    </v-tab>
                    <v-tab
                      v-if="initvalue.loadingorderstatus=='Unloaded'"
                      class="text-capitalize font-weight-regular"
                      :key="2"
                      :href="'#tab-counts'"
                    >
                      Physical Count
                    </v-tab>
                    <v-tab
                     v-if="initvalue.loadingorderstatus=='Unloaded'"
                      ref="loadingTab"
                      class="text-capitalize font-weight-regular"
                      :key="3"
                      :href="'#tab-sales'"
                    >
                      Sales
                    </v-tab>
                    <v-tab
                      class="text-capitalize font-weight-regular"
                      :key="4"
                      :href="'#tab-images'"
                    >
                      Images
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-items'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            :footer-props="footer"
                            :headers="itemHeaders"
                            :items="loadings"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.itemid="{ item }">
                              {{ items.length>0 && item.itemid ? items.find(x=>x._id == item.itemid)['itemname'] : ''  }}
                            </template>
                            <template v-slot:item.itemquantity="{ item }">
                              {{ item.itemquantity.toFixed(3) }}
                            </template>
                            <template v-slot:item.itemweight="{ item }">
                              {{ item.itemweight.toFixed(3) }}
                            </template>
                            <template v-slot:item.itemvolume="{ item }">
                              {{ item.itemvolume.toFixed(3) }}
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      v-if="initvalue.loadingorderstatus=='Unloaded'"
                      :key="2"
                      :value="'tab-counts'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            :footer-props="footer"
                            :headers="countHeaders"
                            :items="counts"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.itemid="{ item }">
                              {{ items.length>0 && item.itemid ? items.find(x=>x._id == item.itemid)['itemname'] : ''  }}
                            </template>
                            <template v-slot:item.unloadQty="{ item }">
                              {{ item.unloadQty.toFixed(3) }}
                            </template>
                            <template v-slot:item.unloadWgt="{ item }">
                              {{ item.unloadWgt.toFixed(3) }}
                            </template>
                            <template v-slot:item.unloadVol="{ item }">
                              {{ item.unloadVol.toFixed(3) }}
                            </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      v-if="initvalue.loadingorderstatus=='Unloaded'"
                      :key="3"
                      :value="'tab-sales'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            loading-text="Loading... Please wait"
                            :footer-props="footer"
                            :headers="salesHeaders"
                            :items="sales"
                            :items-per-page="itemPerPage">
                            <template v-slot:item.itemid="{ item }">
                              {{ items.length>0 && item.itemid ? items.find(x=>x._id == item.itemid)['itemname'] : ''  }}
                            </template>
                            <template v-slot:item.quantity="{ item }">
                              {{ item.quantity.toFixed(3) }}
                            </template>
                            <template v-slot:item.weight="{ item }">
                              {{ item.weight.toFixed(3) }}
                            </template>
                            <!-- <template v-slot:item.volume="{ item }">
                              {{ item.volume.toFixed(3) }}
                            </template> -->
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="4"
                      :value="'tab-images'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-container
                        class="fill-height"
                        fluid
                        style="min-height: 434px"
                      >
                        <v-fade-transition mode="out-in">
                          <v-row>
                            <v-col cols="12" md="6" lg="3" v-for="image in images" :key="image._id">
                              <v-card
                              :ripple="{class: 'ripple-color' }"
                              @click="clickImage(image)"
                              >
                                <v-img
                                  :src="image.imageurl"
                                  height="300"
                                  cover
                                  class="bg-grey-lighten-4"
                                  
                                ></v-img>
                                <v-card-title class="text-h8">
                                  {{ image.imagename }}
                                </v-card-title>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-fade-transition>
                      </v-container>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div class="text-center">
    <v-dialog
      v-model="isImageDialog"
      width="600px"
    >
      <v-card>
        <v-card-text>
          <div>&nbsp;</div>
          <v-row v-if="image">
            <v-col cols="12">
              <v-img
              max-width="580px"
              cover
              :src="image.imageurl"
            ></v-img> 
            </v-col>

          </v-row>
      
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="isImageDialog = false"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "@/config";
import { mapState, mapActions } from 'vuex'

export default {
  name: "LoadingOrderView",

  data() {
    return {
      config,
      initvalue: {},
      transactions: [],
      loadings: [],
      counts: [],
      salesorders: [],
      sales: [],
      images: [],
      selectedTab: "1",
      isImageDialog: false,
      image: null,
      itemHeaders: [
        { text: "Item", value: "itemid" },
        { text: "Quantity", value: "itemquantity", width: "10%" },
        { text: "Weight", value: "itemweight", width: "10%" },
        { text: "Volume", value: "itemvolume", width: "10%" },
      ],
      countHeaders: [
        { text: "Item", value: "itemid" },
        { text: "Quantity", value: "unloadQty", width: "10%" },
        { text: "Weight", value: "unloadWgt", width: "10%" },
        { text: "Volume", value: "unloadVol", width: "10%" },
      ],
      salesHeaders: [
        { text: "Item", value: "itemid" },
        { text: "Quantity", value: "quantity", width: "10%" },
        { text: "Weight", value: "weight", width: "10%" },
        { text: "Volume", value: "volume", width: "10%" },
      ],

      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Item', ['items']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions('LoadingOrder', ["getLoadingOrderRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    clickImage(image){
      this.image = image;
      this.isImageDialog = true;
    },
    calculateLoading(){
      this.loadings = this.transactions.filter(trans=>trans.transtype=='Loading');
      this.counts = this.transactions.filter(trans=>trans.transtype=='Unloading');
      
      this.sales = this.salesorders.map(sale=>{
        return {
          itemid: sale.itemid,
          quantity: sale.quantity,
          weight: this.getWeight(sale.itemid) * sale.quantity,
        };
      });
    },
    getQuantity(itemid, qty){
      let item = this.items.find((x) => x._id == itemid);
      if(item==null) return 0;
      let pieces = qty % 1;
      let itemquantity = (qty - pieces);
      return Math.round(itemquantity);          
    },
    getPieces(itemid, qty){
      let item = this.items.find((x) => x._id == itemid);
      if(item==null) return 0;
      let pieces = qty % 1;
      let itempieces = (pieces * item.itemconvert);
      return Math.round(itempieces);          
    },
    getWeight(itemid){
      let item = this.items.find(item=>item._id==itemid);
      if(item==null) return 0;
      let result = item.itemweight!=null ? item.itemweight : 0;
      return result;
    },
    getVolume(itemid){
      let item = this.items.find(item=>item._id==itemid);
      if(item==null) return 0;
      let result = item.itemvolume!=null ? item.itemvolume : 0;
      return result;
    },
    previewFile(item){
      let params = Object.assign({}, this.initvalue);
      params.fileurl = item.fileurl;
      params.isFromLoadingOrder = true;
      this.$router.push({ name: "FilePreview", params: params })
    },
    Done(){
      this.$router.push({ name: 'LoadingOrderList' });
    },
  },
  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "LoadingOrderList" });
    
    let result = await this.getLoadingOrderRequest(this.initvalue._id);
    this.transactions = Object.assign([], result.transactions);
    this.salesorders = Object.assign([], result.sales);
    this.images = Object.assign([], result.images);
    this.calculateLoading();

    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.users.length==0) await this.getUsersRequest();
    if(this.items.length==0) await this.getItemsRequest();
  },
};
</script>

<style src="./View.scss" lang="scss"/>
